var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { ASK_LUBAV_BUTTON_ENDPOINTS, } from '@backrs_ui/common-ui/src/models/nugget';
import { AskLubavButtonGroup, } from '@backrs_ui/common-ui/src/molecules/AskLubavButtons/AskLubavButtonGroup';
import { Box } from '@mui/material';
import { CareerPathData } from './CareerPathData';
var CAREER_PATH_STRINGS = appStrings.modules.nugget.careerPath;
export var NuggetCareerPath = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var careerPathInfo = _a.careerPathInfo, askLubavButtonGroupProps = _a.askLubavButtonGroupProps, apiKeyOnClick = _a.apiKeyOnClick, askLubavButtonResponse = _a.askLubavButtonResponse;
    var buttonConfigs = new Map([
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_THREE_ROLES_FOR_ME,
            {
                buttonTitle: CAREER_PATH_STRINGS.threeRoles((careerPathInfo === null || careerPathInfo === void 0 ? void 0 : careerPathInfo.name) || ''),
                disabledInProd: false,
                onClick: (_b = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_THREE_ROLES_FOR_ME;
                })) === null || _b === void 0 ? void 0 : _b.onClick,
                actionButtonText: (_c = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_THREE_ROLES_FOR_ME;
                })) === null || _c === void 0 ? void 0 : _c.actionButtonText,
            },
        ],
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_ROLES_BY_TRACK,
            {
                buttonTitle: CAREER_PATH_STRINGS.rolesByTrack,
                disabledInProd: false,
                onClick: (_d = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_ROLES_BY_TRACK;
                })) === null || _d === void 0 ? void 0 : _d.onClick,
                actionButtonText: (_e = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_ROLES_BY_TRACK;
                })) === null || _e === void 0 ? void 0 : _e.actionButtonText,
            },
        ],
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_COMPENSATION,
            {
                buttonTitle: CAREER_PATH_STRINGS.compensationPotential,
                disabledInProd: false,
                onClick: (_f = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_COMPENSATION;
                })) === null || _f === void 0 ? void 0 : _f.onClick,
                actionButtonText: (_g = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_COMPENSATION;
                })) === null || _g === void 0 ? void 0 : _g.actionButtonText,
            },
        ],
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_REQUIREMENTS_TO_SUCCEED,
            {
                buttonTitle: CAREER_PATH_STRINGS.requirements,
                disabledInProd: false,
                onClick: (_h = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_REQUIREMENTS_TO_SUCCEED;
                })) === null || _h === void 0 ? void 0 : _h.onClick,
                actionButtonText: (_j = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_REQUIREMENTS_TO_SUCCEED;
                })) === null || _j === void 0 ? void 0 : _j.actionButtonText,
            },
        ],
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_AM_I_ON_TRACK,
            {
                buttonTitle: CAREER_PATH_STRINGS.onTrack,
                disabledInProd: false,
                requirements: {
                    requireUser: true,
                    requiresResume: true,
                },
                onClick: (_k = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_AM_I_ON_TRACK;
                })) === null || _k === void 0 ? void 0 : _k.onClick,
                actionButtonText: (_l = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_AM_I_ON_TRACK;
                })) === null || _l === void 0 ? void 0 : _l.actionButtonText,
            },
        ],
        [
            ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_AI_DISRUPTION,
            {
                buttonTitle: CAREER_PATH_STRINGS.aiDisruption,
                disabledInProd: true,
                onClick: (_m = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_AI_DISRUPTION;
                })) === null || _m === void 0 ? void 0 : _m.onClick,
                actionButtonText: (_o = apiKeyOnClick.find(function (x) {
                    return (x === null || x === void 0 ? void 0 : x.key) === ASK_LUBAV_BUTTON_ENDPOINTS.CAREER_TRACK_AI_DISRUPTION;
                })) === null || _o === void 0 ? void 0 : _o.actionButtonText,
            },
        ],
    ]);
    return (_jsxs(Box, { children: [askLubavButtonGroupProps && (_jsx(AskLubavButtonGroup, __assign({}, askLubavButtonGroupProps, { buttonConfigs: buttonConfigs, askLubavButtonResponse: askLubavButtonResponse }))), _jsx(CareerPathData, { careerPathInfo: careerPathInfo })] }));
};
